import {LocalDate} from '@js-joda/core';
import type {MailingList, RawMailingList} from '@/types/mailing-list';

export const mapRawToMailingList = (raw : RawMailingList) : MailingList => ({
    ...raw,
    shippingDate: LocalDate.parse(raw.shippingDate),
});
